{
  "dropzoneLabel": "Zonă de plasare",
  "selectPlaceholder": "Selectați un element",
  "tableResizer": "Instrument de redimensionare"
}
